<template>
  <div>
    <v-tabs dark v-model="selectedTab" v-if="hasOrder" vertical>
      <v-tabs-slider color="red"></v-tabs-slider>

      <v-tab>
        <v-icon v-if="$vuetify.breakpoint.mobile"
          >mdi-file-check-outline</v-icon
        >
        <span v-else>{{ $t('labels.orcamento') }}</span>
      </v-tab>
      <v-tab-item>
        <v-form
          ref="formOrcamento"
          v-model="formOrcamentoValid"
          lazy-validation
        >
          <v-card dark tile>
            <v-card-text>
              <v-row dense>
                <v-col cols="2" sm="2" lg="1">
                  <v-text-field
                    outlined
                    dark
                    dense
                    :label="$t('labels.orcamento')"
                    class="text-caption"
                    readonly
                    disabled
                    v-model="order.sequencial"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="2" sm="3" md="2" lg="1">
                  <v-text-field
                    :placeholder="$t('labels.numero')"
                    :label="$t('labels.numero')"
                    class="text-caption"
                    outlined
                    dark
                    dense
                    readonly
                    disabled
                    v-model="order.numero"
                  />
                </v-col>
                <v-col cols="2" md="2" lg="1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-bind="attrs"
                        v-on="on"
                        :label="$t('labels.vendedor')"
                        class="text-caption"
                        outlined
                        dark
                        dense
                        readonly
                        v-model="order.vendedor.CODIGO"
                      >
                      </v-text-field>
                    </template>
                    <span>
                      {{
                        order.vendedor.NOME == 'CONVIDADU'
                          ? 'CONVIDADO'
                          : order.vendedor.NOME
                      }}
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col md="4" v-if="$vuetify.breakpoint.name !== 'lg'">
                  <c-input-date
                    :label="$t('labels.previsaoEntrega')"
                    v-model.trim="order.previsaoEntrega"
                    @change="verifyDate($event, 'previsaoEntrega')"
                    @click:prepend-inner="openMenuPrevisaoEntrega"
                    prepend-inner-icon="mdi-menu"
                    :disabled="
                      (isGuest && order.liberado == 'P') ||
                        order.liberado == 'S'
                    "
                  />
                </v-col>
                <v-col sm="7" lg="5">
                  <v-autocomplete
                    class="text-caption"
                    item-text="DESCRICAO"
                    item-value="CODIGO"
                    :value="order.empresa"
                    :items="getComboBoxListEmp"
                    :label="$t('labels.cliente')"
                    :placeholder="
                      $t('placeholders.autocomplete', {
                        campo: $t('labels.cliente'),
                      })
                    "
                    hide-no-data
                    clearable
                    dark
                    dense
                    outlined
                    return-object
                    :disabled="isGuest"
                    prepend-inner-icon="mdi-text-box-search"
                    @change="changeCompany"
                    @keyup="updateCompanies($event)"
                    @click:prepend-inner.prevent="openDialog('company')"
                    :rules="rulesRequired"
                  >
                    <template v-slot:append-outer>
                      <v-icon v-text="'mdi-plus'" @click="openQuickRegister()">
                      </v-icon>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col sm="5" md="5" lg="4">
                  <v-autocomplete
                    class="text-caption ml-1"
                    item-text="DESCRICAO"
                    item-value="CODIGO"
                    :value="order.departamento"
                    :items="getComboBoxListDeps"
                    :label="$t('labels.departamento')"
                    :placeholder="
                      $t('placeholders.autocomplete', {
                        campo: $t('labels.departamento'),
                      })
                    "
                    hide-no-data
                    clearable
                    dark
                    dense
                    outlined
                    return-object
                    prepend-inner-icon="mdi-text-box-search"
                    @change="
                      updateOrderBehavior(
                        { departamento: $event },
                        'departamento'
                      )
                    "
                    @keyup="updateDepartaments($event)"
                    @click:prepend-inner.prevent="openDialog('departament')"
                    :disabled="isGuest"
                  />
                </v-col>
              </v-row>
              <v-row dense justify="end">
                <v-col
                  cols="6"
                  sm="3"
                  md="3"
                  lg="3"
                  v-if="$vuetify.breakpoint.name == 'lg'"
                >
                  <c-input-date
                    :label="$t('labels.previsaoEntrega')"
                    v-model.trim="order.previsaoEntrega"
                    @change="verifyDate($event, 'previsaoEntrega')"
                    @click:prepend-inner="openMenuPrevisaoEntrega"
                    prepend-inner-icon="mdi-menu"
                  />
                </v-col>
                <v-col cols="2" sm="3" md="3" lg="2">
                  <v-select
                    :items="priceTypes"
                    item-text="text"
                    item-value="value"
                    :label="$t('labels.tipoPreco')"
                    class="text-caption"
                    :value="order.tipoPreco"
                    dark
                    dense
                    outlined
                    :disabled="isGuest || disabledPriceType"
                    @change="
                      updateOrderBehavior({ tipoPreco: $event }, 'tipoPreco')
                    "
                  />
                </v-col>
                <v-col cols="2" md="2" lg="1">
                  <v-select
                    :items="systemCurrency"
                    item-text="cifrao"
                    item-value="index"
                    :label="$t('labels.moeda')"
                    class="text-caption"
                    :value="order.moeda"
                    dark
                    dense
                    outlined
                    :disabled="authUser && authUser.guest != null"
                    @change="updateOrderBehavior({ moeda: $event }, 'moeda')"
                  />
                </v-col>
                <v-col cols="2" sm="4" md="4" lg="3">
                  <c-input-money
                    v-model="totalOrcamentoValue"
                    :label="$t('pdv.totalOrcamento')"
                    dark
                    dense
                    outlined
                    reverse
                    readonly
                    v-bind:valueWhenIsEmpty="'0'"
                    v-bind:options="{
                      locale: 'pt-BR',
                      prefix: '',
                      suffix: componentSuffix,
                      length: 11,
                      precision: componentPrecision,
                    }"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
        <v-card dark class="mt-1">
          <v-card-actions>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  color="amber darken-4"
                  :class="
                    `${
                      $vuetify.breakpoint.name != 'sm' &&
                      $vuetify.breakpoint.name != 'md'
                        ? 'text-overline'
                        : 'text-caption'
                    } mr-1`
                  "
                  small
                  :show="!isGuest"
                  @click="showExtrasDialog = true"
                  :disabled="
                    (isGuest && order.liberado == 'P') || order.liberado == 'S'
                  "
                >
                  <span class="px-1">{{ $t('pdv.extras') }}</span>
                </v-btn>
              </template>
              <span>{{ $t('hints.infosExtras') }}</span>
            </v-tooltip>
            <v-tooltip top v-if="order.empresa.CELULAR != ''">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  color="#25d366"
                  @click="sendWhatsapp(order.empresa.CELULAR)"
                  target="_blank"
                  small
                  :class="
                    `${
                      $vuetify.breakpoint.name != 'sm' &&
                      $vuetify.breakpoint.name != 'md'
                        ? 'text-overline'
                        : 'text-caption'
                    } ml-1`
                  "
                >
                  <v-icon>mdi-whatsapp</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('hints.contactCompany') }}</span>
            </v-tooltip>

            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  @click="deleteOrderDialog = !deleteOrderDialog"
                  color="red"
                  :class="
                    `${
                      $vuetify.breakpoint.name != 'sm' &&
                      $vuetify.breakpoint.name != 'md'
                        ? 'text-overline'
                        : 'text-caption'
                    } mr-1`
                  "
                  small
                  :disabled="isGuest"
                >
                  <span class="px-1">{{ $t('pdv.excluirOrcamento') }}</span>
                </v-btn>
              </template>
              <span>{{ $t('hints.removerOrcamento') }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  @click="closeOrderDialog = !closeOrderDialog"
                  color="green"
                  :class="
                    `${
                      $vuetify.breakpoint.name != 'sm' &&
                      $vuetify.breakpoint.name != 'md'
                        ? 'text-overline'
                        : 'text-caption'
                    }`
                  "
                  small
                  :disabled="
                    (isGuest && order.liberado == 'P') || order.liberado == 'S'
                  "
                >
                  <span class="px-1">{{ $t('pdv.enviarOrcamento') }}</span>
                </v-btn>
              </template>
              <span>{{ $t('hints.enviarOrcamento') }}</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <!-- Início Tab Adicionar Item -->
      <v-tab @change="updateTab">
        <v-icon v-if="$vuetify.breakpoint.mobile">mdi-cart-arrow-down</v-icon>
        <span v-else>{{ $tc('labels.addItem') }}</span>
      </v-tab>
      <v-tab-item>
        <v-card dark>
          <v-row dense>
            <v-col cols="8">
              <v-card>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12">
                      <v-autocomplete
                        class="text-caption"
                        item-text="DESCRICAO"
                        item-value="CODIGO"
                        :value="formItem.item"
                        :items="itemList"
                        :label="$t('menu-home.item')"
                        :placeholder="
                          $t('placeholders.autocomplete', { campo: 'Item' })
                        "
                        hide-no-data
                        clearable
                        dark
                        dense
                        outlined
                        return-object
                        auto-select-first
                        :disabled="
                          (isGuest && order.liberado == 'P') ||
                            order.liberado == 'S'
                        "
                        prepend-inner-icon="mdi-text-box-search"
                        @change="changeItem"
                        @keyup="updateItens($event)"
                        @click:prepend-inner.prevent="openDialog('item')"
                      />
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="4" sm="3">
                      <v-text-field
                        :placeholder="$t('labels.quantidade')"
                        :label="$t('labels.quantidade')"
                        :min="quantidadeStepMin()"
                        :step="quantidadeStepMin()"
                        @blur="validaQuantidade()"
                        @focusout="validaQuantidade()"
                        class="text-caption ml-1"
                        outlined
                        dark
                        dense
                        type="number"
                        v-model="formItem.quantidade"
                        :disabled="
                          (isGuest && order.liberado == 'P') ||
                            order.liberado == 'S'
                        "
                      />
                    </v-col>
                    <v-col cols="4" sm="5">
                      <v-select
                        :items="priceTypes"
                        item-text="text"
                        item-value="value"
                        :label="$t('labels.tipoPreco')"
                        class="text-caption ml-1"
                        v-model="formItem.tipoPreco"
                        dark
                        dense
                        outlined
                        :disabled="
                          isGuest || disabledPriceType || order.liberado == 'S'
                        "
                        @change="updateItemList($event)"
                      />
                    </v-col>
                    <v-col cols="4">
                      <c-input-money
                        v-model="formItem.preco"
                        :label="$t('labels.valor')"
                        dark
                        dense
                        outlined
                        reverse
                        readonly
                        v-bind:valueWhenIsEmpty="'0'"
                        v-bind:options="{
                          locale: 'pt-BR',
                          prefix: '',
                          suffix: componentSuffix,
                          length: 11,
                          precision: componentPrecision,
                        }"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-hover>
                <template v-slot:default="{ hover }">
                  <v-card
                    color="rgba(0,0,0,0.75)"
                    outlined
                    :max-width="$vuetify.breakpoint.mobile ? 300 : undefined"
                  >
                    <v-img
                      :height="180"
                      :max-width="180"
                      contain
                      class="mx-auto"
                      :src="getImage(formItem.item)"
                      aspect-ratio
                    >
                    </v-img>
                    <v-fade-transition>
                      <v-overlay v-if="hover" absolute color="rgb(0,0,0)">
                        <v-tooltip top v-if="formItem.item.imagens">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-on="on"
                              v-bind="attrs"
                              color="blue darken-4"
                              @click="toogleOverlay(formItem.item)"
                              large
                            >
                              <v-icon>mdi-image</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('tabelas.verImagem') }}</span>
                        </v-tooltip>
                      </v-overlay>
                    </v-fade-transition>
                  </v-card>
                </template>
              </v-hover>
            </v-col>
          </v-row>
        </v-card>
        <v-card dark class="mt-1">
          <v-card-actions>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  color="success"
                  :class="
                    `${
                      $vuetify.breakpoint.name != 'sm' &&
                      $vuetify.breakpoint.name != 'md'
                        ? 'text-overline'
                        : 'text-caption'
                    } px-1 py-1`
                  "
                  @click="insertOrderItem()"
                  :loading="searchingItem"
                  small
                  :disabled="disabledAddButton || order.liberado == 'S'"
                >
                  <v-icon small>
                    mdi-cart-arrow-down
                  </v-icon>
                  <span>{{ $tc('labels.addItem') }}</span>
                </v-btn>
              </template>
              <span>{{ $t('hints.addItemOrcamento') }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  color="success"
                  :class="
                    `${
                      $vuetify.breakpoint.name != 'sm' &&
                      $vuetify.breakpoint.name != 'md'
                        ? 'text-overline'
                        : 'text-caption'
                    } px-1 py-1 ml-1`
                  "
                  @click="selectAmbienteDialog = true"
                  small
                  :disabled="order.liberado == 'S'"
                >
                  <v-icon small>
                    mdi-plus
                  </v-icon>
                  <span>{{ $t('labels.ambiente') }}</span>
                </v-btn>
              </template>
              <span>{{ $t('hints.informarAmbiente') }}</span>
            </v-tooltip>
            <v-spacer></v-spacer>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  color="yellow darken-4"
                  :class="
                    `${
                      $vuetify.breakpoint.name != 'sm' &&
                      $vuetify.breakpoint.name != 'md'
                        ? 'text-overline'
                        : 'text-caption'
                    } ml-1 px-1 mr-1`
                  "
                  small
                  @click="clearOrder"
                  :disabled="
                    (isGuest && order.liberado == 'P') || order.liberado == 'S'
                  "
                >
                  <v-icon small>
                    mdi-playlist-remove
                  </v-icon>
                  <span>{{ $t('labels.limparLista') }}</span>
                </v-btn>
              </template>
              <span>{{ $t('hints.removerItensOrcamento') }}</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :class="
                    `${
                      $vuetify.breakpoint.name != 'sm' &&
                      $vuetify.breakpoint.name != 'md'
                        ? 'text-overline'
                        : 'text-caption'
                    } px-1`
                  "
                  color="warning"
                  v-bind="attrs"
                  v-on="on"
                  small
                  @click="reloadOrderItens"
                >
                  <v-icon small>mdi-refresh</v-icon>
                  <span>{{ $t('labels.recarregarItens') }}</span>
                </v-btn>
              </template>
              <span>{{ $t('hints.recarregarItens') }}</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <!-- Fim Tab Adicionar Item -->

      <!-- Inicio tab do carrinho  -->
      <v-tab>
        <v-badge
          color="green"
          :content="orderItens.length"
          bordered
          v-if="orderItens.length > 0"
        >
          <v-icon v-if="$vuetify.breakpoint.mobile">mdi-cart</v-icon>
          <span v-else>{{ $t('pdv.carrinhoOrcamento') }}</span>
        </v-badge>
        <span v-else>{{ $t('pdv.carrinhoOrcamento') }}</span>
      </v-tab>
      <v-tab-item>
        <v-card dark class="py-1 px-1 mx-1">
          <v-card-text>
            <h1 class="white--text">
              {{ $t('labels.orcamento') }}
              <span
                class="font-weight-bold"
                :class="order.liberado == 'W' ? 'yellow--text' : ''"
                >{{ order.numero }}</span
              >
            </h1>
            <h2 class="mt-5">
              {{ $t('labels.totalAPagar') }}
              <span class="green--text font-weight-bold">
                {{ totalOrcamento() }}
                <div
                  class="d-inline-flex"
                  v-for="(valor, index) in totalOrcamentoMoedas"
                  :key="index"
                >
                  <span class="text-overline warning--text">
                    <span class="font-weight-light yellow--text">[</span>
                    {{ valor }}
                    <span class="font-weight-light yellow--text">]</span>
                  </span>
                </div>
              </span>
            </h2>
            <div>
              <span
                :class="
                  `mt-1 ${
                    $vuetify.breakpoint.mobile
                      ? 'subtitle-1 font-weight-medium'
                      : 'text-h6'
                  }`
                "
              >
                {{ $t('labels.totalItens') }} {{ orderItens.length }}</span
              >
            </div>
            <div v-if="!isGuest && order.condicaoPgto">
              <span
                :class="
                  `mt-1 ${
                    $vuetify.breakpoint.mobile
                      ? 'subtitle-1 font-weight-medium'
                      : 'text-h6'
                  }`
                "
              >
                {{ $t('labels.condicaoPagamento') }}
                {{ order.condicaoPgto.NOME }} ({{ order.condicaoPgto.CODIGO }})
              </span>
            </div>
          </v-card-text>
        </v-card>
        <v-card dark class="mt-1">
          <v-card-actions>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  @click="startPreOrder()"
                  color="info"
                  :class="
                    `${
                      $vuetify.breakpoint.name != 'sm' &&
                      $vuetify.breakpoint.name != 'md'
                        ? 'text-overline'
                        : 'text-caption'
                    }`
                  "
                  small
                >
                  <span class="px-1">{{ $t('labels.voltar') }}</span>
                </v-btn>
              </template>
              <span>{{ $t('hints.voltarPDV') }}</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  @click="deleteOrderDialog = !deleteOrderDialog"
                  color="red"
                  :class="
                    `${
                      $vuetify.breakpoint.name != 'sm' &&
                      $vuetify.breakpoint.name != 'md'
                        ? 'text-overline'
                        : 'text-caption'
                    } mr-1`
                  "
                  small
                  :disabled="isGuest"
                >
                  <span class="px-1">{{ $t('pdv.excluirOrcamento') }}</span>
                </v-btn>
              </template>
              <span>{{ $t('hints.removerOrcamento') }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  @click="closeOrderDialog = !closeOrderDialog"
                  color="green"
                  :class="
                    `${
                      $vuetify.breakpoint.name != 'sm' &&
                      $vuetify.breakpoint.name != 'md'
                        ? 'text-overline'
                        : 'text-caption'
                    }`
                  "
                  small
                  :disabled="
                    (isGuest && order.liberado == 'P') || order.liberado == 'S'
                  "
                >
                  <span class="px-1">{{ $t('pdv.enviarOrcamento') }}</span>
                </v-btn>
              </template>
              <span>{{ $t('hints.enviarOrcamento') }}</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <!-- Tab edição de item -->
      <!-- Comentada para que seja melhor implementada no futuro -->
      <v-tab v-if="selectedItem.SEQUENCIAL != null">
        <v-icon v-if="$vuetify.breakpoint.mobile">mdi-pencil</v-icon>
        <span v-else>Editar {{ $tc('labels.produto') }}</span>
      </v-tab>
      <v-tab-item v-if="selectedItem.SEQUENCIAL != null">
        <v-form ref="form">
          <v-card dark tile>
            <v-card-text>
              <v-row no-gutters>
                <v-col cols="2">
                  <v-text-field
                    label="Varejo"
                    :placeholder="
                      $t('placeholders.tipoPreco', { tipo: 'Varejo' })
                    "
                    class="text-caption font-weight-light ml-1 px-0 py-0"
                    outlined
                    dark
                    dense
                    :readonly="!editingItem"
                    v-model="selectedItem.PRECOVAREJO"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    label="Atacado"
                    :placeholder="
                      $t('placeholders.tipoPreco', { tipo: 'Atacado' })
                    "
                    class="text-caption font-weight-light ml-1 px-0 py-0"
                    outlined
                    dark
                    dense
                    :readonly="!editingItem"
                    v-model="selectedItem.PRECOATACADO"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    label="Especial"
                    :placeholder="
                      $t('placeholders.tipoPreco', { tipo: 'Especial' })
                    "
                    class="text-caption font-weight-light ml-1 my-0 px-0 py-0"
                    outlined
                    dark
                    dense
                    :readonly="!editingItem"
                    v-model="selectedItem.PRECOESPECIAL"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    label="Especial 1"
                    :placeholder="
                      $t('placeholders.tipoPreco', { tipo: 'Especial 1' })
                    "
                    class="text-caption font-weight-light ml-1 px-0 py-0"
                    outlined
                    dark
                    dense
                    :readonly="!editingItem"
                    v-model="selectedItem.PRECOESPECIAL2"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    label="Especial 2"
                    :placeholder="
                      $t('placeholders.tipoPreco', { tipo: 'Especial 2' })
                    "
                    class="text-caption font-weight-light ml-1 px-0 py-0"
                    outlined
                    dark
                    dense
                    :readonly="!editingItem"
                    v-model="selectedItem.PRECOESPECIAL3"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    :label="$t('labels.quantidade')"
                    :placeholder="$t('labels.quantidade')"
                    class="text-caption font-weight-light ml-1 px-0 py-0"
                    outlined
                    dark
                    dense
                    v-model="selectedItem.QUANTIDADE"
                    :disabled="order.liberado === 'P' || order.liberado == 'S'"
                    type="number"
                    @blur="alteraQuantidade($event)"
                  />
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="2">
                  <v-text-field
                    :label="`% ${$t('labels.desconto')}`"
                    :placeholder="$t('labels.desconto')"
                    class="text-caption font-weight-light ml-1 px-0 py-0"
                    outlined
                    dark
                    dense
                    v-model="selectedItem.PERCENTUALDESCONTO"
                    disabled
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card dark class="mt-1">
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="
                  (isGuest && order.liberado == 'P') || order.liberado == 'S'
                "
                color="red"
                @click="deleteItem()"
              >
                <v-icon small>
                  mdi-trash-can
                </v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-tab-item>
      <!-- Fim tab edição de item -->
    </v-tabs>
    <div v-else>
      <v-row>
        <v-col cols="12">
          <create-order
            :isGuest="isGuest"
            :disabledPriceType="disabledPriceType"
            :verifyDate="verifyDate"
            :priceTypes="priceTypes"
            :openMenuPrevisaoEntrega="openMenuPrevisaoEntrega"
            @openQuickRegister="openQuickRegister()"
            @closeQuickRegister="closeQuickRegister()"
            @requestNewOrder="requestNewOrder()"
            @changeCompany="changeCompany($event)"
            @openLoadOrder="loadOrderDialog = !loadOrderDialog"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <last-orders @loadOrder="loadOrder($event)" />
        </v-col>
      </v-row>
    </div>
    <!-- Tabela -->
    <v-row v-if="hasOrder">
      <v-col cols="12">
        <v-data-table
          :headers="cartHeader"
          :items="authUser ? orderItens : []"
          item-key="SEQUENCIAL"
          @item-selected="selectItem"
          single-select
          show-select
          dark
          dense
          :hide-default-footer="orderItens.length <= 10"
        >
          <template
            v-for="(header, index) in cartHeader"
            v-slot:[`item.${header.value}`]="{ item }"
          >
            <div
              v-if="['currency', 'decimal'].lastIndexOf(header.format) != -1"
              :key="index"
              :class="$vuetify.breakpoint.mobile ? 'text-caption ' : ''"
            >
              <td
                :class="
                  'S, #####'.lastIndexOf(item.item.EMOFERTA) != -1 &&
                  header.value == 'PRECO'
                    ? 'green--text font-weight-bold'
                    : ''
                "
              >
                {{
                  formatCurrency(order.moeda, item[header.value], header.format)
                }}
              </td>
            </div>
            <div
              v-else-if="header.value == 'QUANTIDADE'"
              :key="index"
              :class="$vuetify.breakpoint.mobile ? 'text-caption ' : ''"
            >
              {{
                item.QUANTIDADE - parseInt(item.QUANTIDADE, 10) > 0
                  ? formatDecimal(item.QUANTIDADE, 4, 2)
                  : formatDecimal(item.QUANTIDADE, 0, 0)
              }}
            </div>
            <div
              v-else-if="header.value.lastIndexOf('item.') != -1"
              :key="index"
              :class="$vuetify.breakpoint.mobile ? 'text-caption ' : ''"
            >
              {{ item.item[header.value.substr(5, header.value.length)] }}
            </div>

            <div
              v-else
              :key="index"
              :class="$vuetify.breakpoint.mobile ? 'text-caption ' : ''"
            >
              {{ item[header.value] }}
            </div>
          </template>
          <template v-slot:item.imagens.image_name="{ item }">
            <v-tooltip top v-if="item.item.imagens">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  @click="toogleOverlay(item.item)"
                  x-small
                >
                  <v-icon color="blue">mdi-image-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('tabelas.verImagem') }}</span>
            </v-tooltip>
            <div v-else>
              <span class="red--text">X</span>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <extras-info
      v-if="showExtrasDialog"
      :showDialog="showExtrasDialog"
      @close="showExtrasDialog = false"
      :codigo-empresa="order.empresa.CODIGO"
    />

    <overlayItem
      :isVisible="overlay.overlay"
      :isAbsolute="overlay.absolute"
      :imagesList="imagesList"
      :item="overlay.item"
      :especificacoes="overlay.especificacoes"
      :opacity="0.8"
      v-model="overlay.model"
      v-if="overlay.overlay"
      @closeOverlay="closeOverlay"
    />
    <!-- Fim da Tabela -->

    <load-order
      v-if="loadOrderDialog"
      :isGuest="isGuest"
      @loadOrder="loadOrder($event)"
      :showDialog="loadOrderDialog"
      @close="loadOrderDialog = !loadOrderDialog"
    />
    <send-whatsapp
      :showDialog="showWppDialog"
      @close="showWppDialog = !showWppDialog"
      :numeroCelular="numWhatsapp"
      v-if="showWppDialog"
    />
    <leave-route-dialog ref="leaveRouteDialog" v-model="leaveRouteDialog" />
    <confirm-dialog ref="confirmDialog" v-model="confirmDialog" />
    <item-delivery v-if="authUser" ref="itemDelivery" v-model="itemDelivery" />
    <confirm-pending-bills
      ref="confirmPendingBills"
      v-model="confirmPendingBills"
    />
    <departament-select
      v-if="departamentSelectDialog"
      :show-dialog="departamentSelectDialog"
      @object-pin="objectPin($event, 'departament')"
      @close="departamentSelectDialog = !departamentSelectDialog"
    />
    <company-select
      v-if="companySelectDialog"
      :show-dialog="companySelectDialog"
      @object-pin="objectPin($event, 'company')"
      @close="companySelectDialog = !companySelectDialog"
    />
    <item-select
      v-if="itemSelectDialog"
      :show-dialog="itemSelectDialog"
      :isGuest="isGuest"
      @object-pin="objectPin($event, 'item')"
      @addItens="objectPin($event, 'item')"
      @close="itemSelectDialog = !itemSelectDialog"
    />
    <close-order
      v-if="closeOrderDialog"
      :show-dialog="closeOrderDialog"
      @close-order="closeOrder"
      @close-dialog="closeOrderDialog = !closeOrderDialog"
    />
    <delete-order
      v-if="deleteOrderDialog"
      :show-dialog="deleteOrderDialog"
      @delete-order="deleteOrder"
      @close-dialog="deleteOrderDialog = !deleteOrderDialog"
    />

    <template v-if="authUser && !authUser.guest">
      <template v-if="dialogFormQuickRegister">
        <quick-register
          :formValid.sync="formQuickRegisterValid"
          :visible="dialogFormQuickRegister"
          @changeCompany="closeQuickRegister"
          @close="closeQuickRegister"
        />
      </template>
      <template v-if="dialogTabParcelamento">
        <parcelamento
          :isPDV="true"
          :visible="dialogTabParcelamento"
          :tabParcelamentoValid.sync="tabParcelamentoValid"
          :tabParcelamento="tabParcelamento"
          :addParcelamento="addParcelamento"
          @close="closeTabParcelamento"
        />
      </template>

      <payment-select
        ref="paymentConditionSelect"
        v-model="openPaymentSelectDialog"
        @object-pin="objectPin($event, 'paymentCondition')"
      />
    </template>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="true"
      transition="scale-transition"
      bottom
      :position-x="posXmenuPrevisao"
      :position-y="posYmenuPrevisao"
    >
      <v-list dense>
        <v-list-item-group v-model="selectedItemPrevisaoEntrega">
          <v-list-item
            v-for="(item, i) in itemsTipoPrevisao"
            :key="i"
            color="red"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-title @click="setTipoPrevisaoEntrega(item)">{{
              item.title
            }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <select-ambiente
      :showDialog="selectAmbienteDialog"
      @close="selectAmbienteDialog = false"
      @salvarAmbiente="setarAmbiente($event)"
    />
    <item-diversos
      v-if="itemDiversosDialog"
      :showDialog="itemDiversosDialog"
      @saveItem="saveItemDiverso"
      @close="changeItem(null)"
      v-model="formItem.item"
      :currency="systemCurrency[order.moeda].cifrao"
    />
    <message-dialog
      :showDialog="showMessageDialog"
      :message="messageToDialog"
      @close="showMessageDialog = !showMessageDialog"
    />

    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import { currencyMixin } from '@/mixins/object/currency/CurrencyMixin'
import { parcelMixin } from '@/mixins/object/parcels/ParcelMixin'
import { flagsMixin } from '@/mixins/object/flags/FlagsMixin'
// import SendWhatsapp from '@/components/object/company/SendWhatsapp'
import {
  getTodayDateTimeLocal,
  formatDateToTimestamps,
  requiredField,
  translateList,
} from '@/utils/utils'
export default {
  components: {
    SendWhatsapp: () => import('@/components/object/company/SendWhatsapp'),
    LeaveRouteDialog: () =>
      import('@/components/shared/base-dialog/LeaveRouteDialog'),
    ConfirmDialog: () => import('@/components/shared/base-dialog/Confirm'),
    CreateOrder: () => import('@/components/unique/pdv-balcao/CreateOrder'),
    LoadOrder: () => import('@/components/unique/pdv-balcao/LoadOrder'),
    CloseOrder: () => import('@/components/unique/pdv-balcao/CloseOrder'),
    DeleteOrder: () => import('@/components/unique/pdv-balcao/DeleteOrder'),
    LastOrders: () => import('@/components/unique/pdv-balcao/LastOrders'),
    DepartamentSelect: () => import('@/components/object/departament/Select'),
    CompanySelect: () => import('@/components/object/company/Select'),
    ItemSelect: () =>
      import(/* webpackPrefetch: true */ '@/components/object/item/Select'),
    ItemDelivery: () => import('@/components/object/item/ItemTaxaEntrega'),
    PaymentSelect: () => import('@/components/object/payment-condition/Select'),
    QuickRegister: () => import('@/views/company/QuickRegister'),
    Parcelamento: () => import('@/views/parcel/Register'),
    cInputMoney: () =>
      import('@/components/shared/base-input/BaseInputMoney.vue'),
    ConfirmPendingBills: () =>
      import('@/components/unique/pdv-balcao/ConfirmPendingBills'),
    cInputDate: () => import('@/components/shared/base-input/BaseInputDate'),
    overlayItem: () => import('@/components/shared/base-overlay/BaseOverlay'),
    ExtrasInfo: () => import('@/components/unique/pdv-balcao/ExtrasInfo'),
    MessageDialog: () =>
      import('@/components/shared/base-dialog/MessageDialog'),
    ItemDiversos: () => import('@/components/object/item/ItemDiversos'),
    SelectAmbiente: () => import('@/components/object/item/SelectAmbiente'),
  },
  mixins: [currencyMixin, parcelMixin, flagsMixin],
  data: () => {
    return {
      numWhatsapp: '',
      menu: false,
      posXmenuPrevisao: 0,
      posYmenuPrevisao: 0,
      itemsTipoPrevisao: [
        { title: 'Retira', value: 'Retira', icon: 'mdi-dolly' },
        { title: 'Entrega', value: 'Entrega', icon: 'mdi-truck-delivery' },
        {
          title: 'Entrega Futura',
          value: 'Futura',
          icon: 'mdi-calendar-clock',
        },
      ],
      selectedItemPrevisaoEntrega: undefined,
      newQuantity: {},
      showWppDialog: false,
      selectAmbienteDialog: false,
      showMessageDialog: false,
      messageToDialog: [],
      deleteOrderDialog: false,
      closeOrderDialog: false,
      showExtrasDialog: false,
      openPaymentSelectDialog: false,
      itemSelectDialog: false,
      departamentSelectDialog: false,
      companySelectDialog: false,
      showSearchItemDialog: false,
      openSelectDialog: false,
      leaveRouteDialog: false,
      confirmDialog: false,
      itemDelivery: false,
      confirmPendingBills: false,
      searchingItem: false,
      editingItem: false,
      editingParcelamento: false,
      hasOrder: false,
      formQuickRegister: {},
      formOrcamentoValid: true,
      loadOrderDialog: false,
      itemDiversosDialog: false,
      formEdit: {
        precoVarejo: '',
        precoAtacado: '',
        precoEspecial: '',
        precoEspecial2: '',
        precoEspecial3: '',
        quantidade: '',
        tipoPreco: '',
        ambienteInformado: '',
      },
      formItem: {
        item: {},
        quantidade: 1,
        preco: 0,
        desconto: 0,
        tipoPreco: undefined,
        condicaoPgto: undefined,
      },
      itemsSelected: [],
      selectedTab: 1,
      selectedItem: {},
      timer: null,
      formQuickRegisterValid: false,
      dialogFormQuickRegister: false,
      dialogTabParcelamento: false,
      tabParcelamentoValid: false,
      tabParcelamento: {
        prefix: '',
        condicao: '',
        tipoVenda: undefined,
        ct: undefined,
        faseObra: null,
        valorTotal: 0.0,
        valor: 0.0,
        parcelas: [],
      },
      newParcelamentos: [],
      overlay: {
        overlay: false,
        cycle: false,
        absolute: false,
        color: 'dark',
        model: 0,
        especificacoes: '',
        item: {},
      },
      imagesList: [],
    }
  },
  computed: {
    disabledAddButton() {
      if (
        (this.isGuest && this.order.liberado == 'P') ||
        (this.formItem.preco <= 0 &&
          this.getFlagSetado('BloqueiaPrecoZeroNoOrcamento'))
      )
        return true
      else return false
    },
    componentSuffix() {
      if (this.authUser)
        return this.getCurrencyLocation(this.systemCurrency[this.order.moeda])
      else return ''
    },
    componentPrecision() {
      if (this.authUser) return this.getCurrencyFractionDigits(this.order.moeda)
      else return 2
    },
    disabledPriceType() {
      if (this.getFlagSetado('AssumeTipoPrecoSoDoCadastroEmpresas')) {
        // disable true
        return true
      } else if (
        this.order.sequencial > 0 &&
        (this.getFlagSetado('NaoTrocaTipoPrecoNoOrcamento') ||
          this.getFlagSetado('NaoTrocaTipoPrecoNoOrcamentoComItens'))
      ) {
        return true
      } else {
        // disable false
        return false
      }
    },

    // PDV Balcao Module
    ...mapState('pdvBalcaoModule/orderModule', ['order']),
    ...mapGetters({
      orderItens: 'pdvBalcaoModule/orderItensModule/getOrderItems',
      orderType: 'pdvBalcaoModule/orderModule/getOrderType',
    }),
    // Auth Module
    ...mapState('authModule', ['authUser']),
    // Item Module
    ...mapState('itemModule', ['typePriceFieldname']),

    ...mapGetters({
      itemList: 'itemModule/getComboBoxList',
      systemCurrency: 'systemModule/getSystemCurrencies',
    }),
    // Departament Module
    ...mapState('departamentModule', ['departamentList']),
    ...mapGetters({
      getComboBoxListDeps: 'departamentModule/getComboBoxListDeps',
    }),
    // Currencies Module
    ...mapGetters({
      codigoItemDiversos: 'systemModule/getCodigoItemDiversos',
    }),
    //Currency Store
    ...mapState('currencyModule', ['currency']),
    // Company Module
    ...mapState('companyModule', ['companyList']),
    ...mapGetters({
      getComboBoxListEmp: 'companyModule/getComboBoxList',
    }),
    rulesRequired() {
      let rules = []
      const rule = requiredField('Empresa')
      rules.push(rule)
      return rules
    },
    priceTypes() {
      let defaultList = [
        { text: 'Preço Varejo', value: 'PRECOVAREJO' },
        { text: 'Preço Atacado', value: 'PRECOATACADO' },
        { text: 'Preço Especial', value: 'PRECOESPECIAL' },
      ]

      if (this.getFlagSetado('PrecoEspecial23')) {
        let special23List = [
          { text: 'Preço Especial 2', value: 'PRECOESPECIAL2' },
          { text: 'Preço Especial 3', value: 'PRECOESPECIAL3' },
        ]
        // concatena duas listas
        Array.prototype.push.apply(defaultList, special23List)
      }
      return defaultList
    },
    siglaPriceTypes() {
      let siglaPriceType =
        this.formItem.tipoPreco == 'PRECOVAREJO'
          ? 'V'
          : this.formItem.tipoPreco == 'PRECOATACADO'
          ? 'A'
          : this.formItem.tipoPreco == 'PRECOESPECIAL'
          ? 'E'
          : this.formItem.tipoPreco == 'PRECOESPECIAL2'
          ? '2'
          : this.formItem.tipoPreco == 'PRECOESPECIAL3'
          ? '3'
          : 'V'
      return siglaPriceType
    },
    indexPriceTypes() {
      let index =
        this.formItem.tipoPreco == 'PRECOVAREJO'
          ? '0'
          : this.formItem.tipoPreco == 'PRECOATACADO'
          ? '1'
          : this.formItem.tipoPreco == 'PRECOESPECIAL'
          ? '2'
          : this.formItem.tipoPreco == 'PRECOESPECIAL2'
          ? '3'
          : this.formItem.tipoPreco == 'PRECOESPECIAL3'
          ? '4'
          : '0'
      return index
    },
    cartHeader() {
      let cartHeader = [
        { text: 'Código', label: 'codigo', value: 'item.CODIGO' },
        {
          text: 'Descrição',
          label: 'descricao',
          value: 'item.DESCRICAO',
          width: this.$vuetify.breakpoint.mobile ? '300' : '500',
        },
        {
          text: 'Imagem',
          label: 'imagem',
          value: 'imagens.image_name',
          align: 'center',
        },
        { text: 'TP', label: 'tipoPreco', value: 'TIPOPRECO', align: 'center' },
        {
          text: 'Quantidade',
          label: 'quantidade',
          value: 'QUANTIDADE',
          align: 'center',
        },
        {
          text: '% Desconto',
          label: 'desconto',
          value: 'PERCENTUALDESCONTO',
          align: 'center',
          format: 'decimal',
        },
        {
          text: 'Valor Unitário',
          label: 'valorUnitario',
          value: 'PRECO',
          format: 'currency',
        },
        {
          text: 'Desc. Unitário',
          label: 'descontoUnitario',
          value: 'VALORDESCONTOUNITARIO',
          format: 'currency',
        },
        {
          text: 'Total',
          label: 'total',
          value: 'VALORTOTAL',
          format: 'currency',
        },
      ]
      return translateList(cartHeader)
    },
    totalOrcamentoMoedas() {
      let totais = []
      let total = 0
      if (this.authUser) {
        let valorTotalMoedaOrcamento = this.convertePreco(
          this.order.moeda,
          this.totalOrcamentoValue
        )
        this.systemCurrency.forEach((currency) => {
          if (currency.index !== this.order.moeda) {
            let valor = this.calculaCambio(currency, valorTotalMoedaOrcamento)
            total = this.formatCurrency(currency.index, valor)
            totais.push(`${total}`)
          }

          total = 0
        })
      }
      return totais
    },
    totalOrcamentoValue() {
      const total = this.orderItens.reduce((subTotal, item) => {
        let soma =
          item.VALORTOTAL ??
          parseFloat(item.QUANTIDADE) * parseFloat(item.VALOR)
        return (subTotal += soma)
      }, 0.0)

      /*
       Forçar a soma total ter apenas as casas definidas no CTRL S (desktop).
       Soma gerava o valor 24.06000002
      */
      return total.toFixed(this.componentPrecision) * 1
    },
    isGuest() {
      if (this.authUser && this.authUser.guest != null) return true
      else return false
    },
  },
  methods: {
    /*
     * Converte o valor para a moeda0 quando a moeda do orçamento é diferente de 0
     */
    convertePreco(moedaorcamento, valor) {
      let cambio = this.getCambioAtual(moedaorcamento)
      let valorMoeda0 = parseFloat(valor) * parseFloat(cambio)

      return valorMoeda0
    },
    async sendWhatsapp(celular) {
      this.numWhatsapp = `${celular}`
      this.showWppDialog = !this.showWppDialog
    },
    setarAmbiente($e) {
      this.selectAmbienteDialog = false
      if ($e.length > 0) this.formEdit.ambienteInformado = $e
      this.$toasted.info(
        `${this.$t('labels.ambiente')} ${this.formEdit.ambienteInformado}`
      )
    },
    quantidadeStepMin: function() {
      if (this.formItem.item)
        return parseFloat(this.formItem.item.EMBALAGEMVENDA) ?? 1
    },
    validaQuantidade() {
      if (!this.formItem.item) return
      let quantidade = this.formItem.quantidade
      let qntEmbalagem = this.formItem.item.EMBALAGEMVENDA ?? 1
      let result =
        parseFloat(quantidade).toFixed(2) / parseFloat(qntEmbalagem).toFixed(2)
      let diff = Math.round(result) - result
      if (
        (diff > 0.01 || diff < -0.01) &&
        this.getFlagSetado('VerificaEmbalagensNosPrecos')
      ) {
        let sugestaoQnt = parseFloat(Math.ceil(result) * qntEmbalagem).toFixed(
          2
        )
        this.formItem.quantidade = parseFloat(sugestaoQnt)
        this.$toasted.error(
          'Item: [' +
            this.formItem.item.CODIGO +
            '] ' +
            this.$t('validation-messages.quantityMultiplies', {
              quantidade: this.formItem.quantidade,
            })
        )
        this.$toasted.error(
          this.$t('validation-messages.quantityAlter', {
            quantidade: sugestaoQnt,
          }) +
            ' ' +
            this.formItem.item.UM
        )
      }
    },
    async saveItemDiverso() {
      this.changeItem(this.formItem.item)
      await this.insertOrderItem()
      this.itemDiversosDialog = false
    },
    openMenuPrevisaoEntrega(value) {
      const { clientX, clientY } = value
      this.posXmenuPrevisao = clientX + 10
      this.posYmenuPrevisao = clientY + 10
      this.menu = !this.menu
    },
    setTipoPrevisaoEntrega(value) {
      this.order.tipoPrevisaoEntrega = value.value
    },

    // eslint-disable-next-line
    customFilter(item, queryText, itemText) {
      const codigo = item.CODIGO.toLowerCase()
      const codBarras = item.CODIGOBARRAS ? item.CODIGOBARRAS.toLowerCase() : ''
      const codBarras2 = item.CODIGOBARRAS2
        ? item.CODIGOBARRAS2.toLowerCase()
        : ''
      const descricao = item.DESCRICAO.toLowerCase()
      const descricaoG = item.DESCRICAOG ? item.DESCRICAOG.toLowerCase() : ''
      const codFabricante = item.CODIGOFABRICANTE
        ? item.CODIGOFABRICANTE.toLowerCase()
        : ''
      const searchText = queryText.toLowerCase()

      return (
        codigo.indexOf(searchText) > -1 ||
        codFabricante.indexOf(searchText) > -1 ||
        codBarras.indexOf(searchText) > -1 ||
        codBarras2.indexOf(searchText) > -1 ||
        descricao.indexOf(searchText) > -1 ||
        descricaoG.indexOf(searchText) > -1
      )
    },
    async verifyDate(value, property) {
      let yearValue = value.split('-')[0]
      let yearToday = getTodayDateTimeLocal()
        .substring(0, 10)
        .split('-')[0]

      if (yearValue < yearToday || yearValue > 2100) {
        let nValue = value.replace(value.substring(0, 4), yearToday)
        await this.$nextTick()
        this.order[property] = nValue
      }
    },
    totalOrcamento(moeda) {
      if (this.authUser)
        return this.formatCurrency(
          moeda ? moeda : this.order.moeda,
          this.totalOrcamentoValue
        )
      else return this.formatCurrency(0, 0)
    },
    openDialog(dialog) {
      if (dialog === 'departament')
        this.departamentSelectDialog = !this.departamentSelectDialog
      else if (dialog === 'company')
        this.companySelectDialog = !this.companySelectDialog
      else if (dialog === 'item') this.itemSelectDialog = !this.itemSelectDialog
    },

    ...mapActions({
      // PDV Balcão Module
      addOrderItem: 'pdvBalcaoModule/orderItensModule/addOrderItem',
      removeOrderItem: 'pdvBalcaoModule/orderItensModule/removeOrderItem',
      updateOrderItem: 'pdvBalcaoModule/orderItensModule/updateOrderItem',
      getOrderItens: 'pdvBalcaoModule/orderItensModule/getOrderItens',
      resetOrderItens: 'pdvBalcaoModule/orderItensModule/resetOrderItens',
      setOrder: 'pdvBalcaoModule/orderModule/setOrder',
      setPreOrder: 'pdvBalcaoModule/orderModule/setPreOrder',
      newOrder: 'pdvBalcaoModule/orderModule/newOrder',
      updateOrder: 'pdvBalcaoModule/orderModule/updateOrder',
      resetOrder: 'pdvBalcaoModule/orderModule/resetOrder',
      deleteOrderAPI: 'pdvBalcaoModule/orderModule/deleteOrder',
      loadOrderAPI: 'pdvBalcaoModule/orderModule/loadOrder',
      // Item Module
      getItemsAPI: 'itemModule/getItens',
      getItemAPI: 'itemModule/getItem',
      clearItemList: 'itemModule/clearItemList',
      // Company Module
      getCompaniesAPI: 'companyModule/getCompanies',
      // Departament Module
      getDepartamentsAPI: 'departamentModule/getDepartaments',
      // Company Module
      getCompanyAPI: 'companyModule/getCompany',
      // Loading Dialog Module
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setLoadingDialogMessage: 'dialogModule/setLoadingDialogMessage',
      // Bills Module
      getPendingBillsResumePDV: 'billsModule/getPendingBillsResumePDV',
      // Currency Module
      getcurrencyAPI: 'currencyModule/getCurrency',
    }),

    ...mapActions('parcelModule', ['deleteParcel']),
    ...mapActions({ updateItems: 'itemModule/updateItemList' }),

    // método atualiza apenas a consulta de itens
    async updateItemList(value) {
      let query = {}
      /*
       *  Se o atributo item vier, indica que foi feito uma troca do tipo Preço na Tab "Adicionar Item"
       *  Ignora atualização baseado no orçamento "updateTab" (baseado no orçamento)
       *  Se não vier nada, a busca será baseada apenas no formItem
       *  No final, atualiza o preço da v-model formItem.preco
       */
      if (!value) await this.updateTab()
      else {
        query.codigo = this.formItem.item.CODIGO
      }
      // monta a query chama updateItems
      query = {
        ...query,
        tipoPreco: this.formItem.tipoPreco,
        moedaBalcao: this.formItem.moeda,
        condicaoPgto: this.formItem.condicaoPgto,
        pdvBalcao: true,
      }
      await this.updateItems(query)

      if (value) this.updatePriceTab()
    },

    updatePriceTab() {
      this.$nextTick(function() {
        if (this.itemList.length == 1) this.changeItem(this.itemList[0])
      })
    },

    updateTab() {
      this.$nextTick(function() {
        this.formItem.tipoPreco = this.order.tipoPreco
        this.formItem.moeda = this.order.moeda
        this.formItem.condicaoPgto = this.order.condicaoPgto
      })
    },

    validateOrderToParcel() {
      let result = true
      if (!this.hasOrder) {
        this.$toasted.error(this.$t('pdv.validateOrderToParcelError1'), {
          duration: null,
        })
        result = false
      }

      if (this.totalOrcamentoValue <= 0) {
        this.$toasted.error(this.$t('pdv.validateOrderToParcelError2'), {
          duration: null,
        })
        result = false
      }

      return result
    },

    async addParcelamento() {
      if (!this.validateOrderToParcel()) return

      if (!this.tabParcelamentoValid) return

      if (this.tabParcelamento && this.tabParcelamento.parcelas.length > 0) {
        this.newParcelamentos = this.tabParcelamento.parcelas

        // seta a condicao de pgto do orçamento
        this.order.condicaoPgto = this.tabParcelamento.tipoVenda
        this.order.ct = this.tabParcelamento.ct
        this.order.valorAcrescimoFinanceiro = this.tabParcelamento.valorAcrescimoFinanceiro

        const response = await this.submitOrder()

        // se houver algum erro, pode corrigir o parcelamento, senão encerra
        if (response) await this.closeTabParcelamento()
      }
    },

    newParcel() {
      if (!this.validateOrderToParcel()) return

      this.closeTabParcelamento()
      const totalParcelamento = this.totalOrcamentoValue
      this.tabParcelamento.valorTotal = totalParcelamento
      this.tabParcelamento.valor = totalParcelamento

      this.tabParcelamento.tipoVenda =
        this.order.condicaoPgto ?? this.order.empresa.tipoVenda ?? undefined

      this.tabParcelamento.condicao = this.order.condicaoPgto
        ? this.order.condicaoPgto.NOME
        : this.order.empresa.tipoVenda
        ? this.order.empresa.tipoVenda.NOME
        : undefined

      // verificar se o orçamento já tem CT
      if (this.order.ct) {
        this.tabParcelamento.ct = this.order.ct
      }
    },

    closeTabParcelamento() {
      this.tabParcelamento = {
        prefix: '',
        condicao: '',
        tipoVenda: undefined,
        ct: undefined,
        faseObra: null,
        valorTotal: 0.0,
        valor: 0.0,
        valorAcrescimoFinanceiro: 0.0,
        parcelas: [],
        parcela_fases: [],
      }

      this.dialogTabParcelamento = !this.dialogTabParcelamento
    },

    // Itens Functions

    async updateItens($event) {
      const keys = ['ArrowDown', 'ArrowRight', 'ArrowLeft', 'ArrowUp']
      try {
        const { code } = $event
        if (keys.lastIndexOf(code) >= 0) return

        this.searchingItem = true
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          let param = $event && $event.target.value ? $event.target.value : null
          if (!param || param.trim().length <= 0) return

          // evitar refazer a consulta
          if (
            this.itemList &&
            this.itemList.find((el) => el.DESCRICAO == param)
          )
            return

          param = param
            .trim()
            .split('-')[0]
            .trim()

          let obj = {
            page: 1,
            tipoPreco: this.indexPriceTypes,
            hibrido: param,
          }

          this.getDados(obj, 'item')
        }, 600)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.searchingItem = false
      }
    },
    // Departament Functions
    async updateDepartaments($event) {
      try {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          let param = $event && $event.target.value ? $event.target.value : null

          if (!param || param.trim().length <= 0) return

          let obj = { page: 1 }

          if (param.lastIndexOf('-') == -1) {
            obj.hibrido = param
          } else {
            param = param
              .trim()
              .split('-')[0]
              .trim()

            obj.codigo = parseInt(param)
          }

          this.getDados(obj, 'departament')
        }, 600)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    // Company Functions
    async updateCompanies($event) {
      try {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          let param = $event && $event.target.value ? $event.target.value : null
          if (!param || param.trim().length <= 0) return

          let obj = { page: 1 }

          if (param.lastIndexOf('-') == -1) {
            obj.hibrido = param
          } else {
            param = param
              .trim()
              .split('-')[0]
              .trim()

            obj.codigo = parseInt(param)
          }

          this.getDados(obj, 'company')
        }, 600)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    openQuickRegister() {
      // this.$router.push({ name: 'pdv.register.company' })
      this.dialogFormQuickRegister = !this.dialogFormQuickRegister
    },

    async getPendingBills(value) {
      if (value && value.CODIGO > 0) {
        let response = await this.getPendingBillsResumePDV(value.CODIGO)

        let array = response.map((element) => {
          return `${this.$t('labels.titulo')}: ${element.DOCUMENTO} | ${this.$t(
            'labels.vencimento'
          )}: ${
            element.VENCIMENTO
              ? new Date(element.VENCIMENTO + '-03:00').toLocaleDateString(
                  'pt-BR'
                )
              : null
          } | Saldo: ${parseFloat(element.SALDO).toFixed(2)} | ${this.$t(
            'labels.filial'
          )}:${element.FILIAL}`
        })

        return array
      }
    },

    async changeCompany(value) {
      if (!value) {
        if (this.order.empresa.CODIGO != '') this.order.empresa.CODIGO = ''
        if (this.order.empresa.DESCRICAO != '')
          this.order.empresa.DESCRICAO = ''
        return
      }

      try {
        if (!this.isGuest) {
          // let canContinue = true
          const array = await this.getPendingBills(value)
          let messages = []
          if (value.obsBalcao) {
            messages.push(`${value.obsBalcao}`)
          }
          if (value.bloqueado) {
            messages.push(`${this.$t('pdv.empresaBloqueada')}`)
          }

          if (messages.length > 0) {
            this.messageToDialog = messages
            this.showMessageDialog = true
            if (value.bloqueado) return
          }

          // sempre chamará títulos pendentes (se houver)
          if (array && array.length > 0) {
            await this.$refs.confirmPendingBills.open(
              `${this.$t('labels.titulosPendentes')}`,
              array,
              {
                color: 'error darken-3',
                width: 500,
              }
            )
          }
        }

        // quando a empresa tem alteração, precisa verificar a condição de pagamento
        if (this.order.empresa.CODIGO !== value.CODIGO) {
          this.order.condicaoPgto = undefined

          // somente se o orçamento existir, faz update no orçamento
          if (this.order.sequencial > 0) {
            await this.verifyFlagPaymentCondition(value.tipoVenda)
            await this.updateOrderBehavior({ empresa: value }, 'empresa')
          } else {
            this.order.empresa = value
            await this.verifyFlagPaymentCondition(value.tipoVenda)

            // verifica flag seta tipo preço da empresa
            // if (this.getFlagSetado('AssumeTipoPrecoSoDoCadastroEmpresas')) {
            const searchType =
              this.order.empresa.TIPOPRECO &&
              this.order.empresa.TIPOPRECO.length > 0
                ? parseInt(this.order.empresa.TIPOPRECO)
                : 0
            const type = this.typePriceFieldname.filter(
              (element, index) => index == searchType
            )
            this.order.tipoPreco = type[0] ?? this.order.tipoPreco
            // }
          }
        }
      } catch (error) {
        this.$toasted.error(error)
      }
    },

    async closeQuickRegister(value) {
      if (value) {
        try {
          await this.getDados({ page: 1, codigo: value }, 'company')
          if (this.companyList.length > 0) {
            const company = this.getComboBoxListEmp.filter(
              (el) => el.CODIGO == value
            )[0]
            this.changeCompany(company, 'empresa')
          }
        } catch (error) {
          this.$toasted.error(error, { duration: null })
        }
      }
      this.dialogFormQuickRegister = !this.dialogFormQuickRegister
    },
    // Search General Functions
    async getDados(payload, tipo) {
      try {
        if (tipo === 'item') {
          payload.pdvBalcao = true
          payload.condicaoPgto = this.order.condicaoPgto
          payload.moedaBalcao = this.order.moeda
          await this.getItemsAPI({ query: payload })
          this.searchingItem = false
        } else if (tipo === 'departament') {
          await this.getDepartamentsAPI(payload)
          this.searchingItem = false
        } else if (tipo === 'company') {
          await this.getCompaniesAPI(payload)
          this.searchingItem = false
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    async updateOrderBehavior(value, property) {
      if (!value) return

      switch (property) {
        case 'empresa':
        case 'departamento':
          if (
            parseInt(value[property].CODIGO) ==
            parseInt(this.order[property].CODIGO)
          )
            return
          break

        default:
          // moeda e tipo preco entram aqui
          if (value[property] == this.order[property]) return
          break
      }

      const canContinue = await this.validateOrder()
      if (!canContinue) return

      var oldOrder = Object.assign({}, this.order)

      try {
        this.setLoadingDialogMessage(
          `${this.$t('pdv.updateOrderBehavior')} (${property})`
        )
        this.showLoadingDialog(true)
        let updatedOrder = Object.assign(this.order, value)

        const response = await this.updateOrder(updatedOrder)

        await this.reloadOrderItens()

        await this.updateItemList()

        this.$toasted.success(response)
      } catch (error) {
        // recarrega orcamento
        await this.loadOrder({ sequencial: oldOrder.sequencial }, false)
        this.$toasted.error(error)
      } finally {
        this.showLoadingDialog(false)
      }
    },

    changeItem(item) {
      if (item && item.CODIGO === this.codigoItemDiversos)
        this.itemDiversosDialog = true

      if (item) {
        let currency = this.systemCurrency[this.order.moeda].cifrao
        this.formItem.item = item
        this.formItem.preco = item['PRECOITEM'][currency] // pegar preço da moeda
        this.formItem.quantidade = item.EMBALAGEMVENDA
          ? parseFloat(item.EMBALAGEMVENDA)
          : 1
      } else {
        if (this.itemDiversosDialog) this.itemDiversosDialog = false
        this.$nextTick(function() {
          this.formItem.item = {}
          this.formItem.preco = 0.0
          this.formItem.quantidade = 1
        })
      }
    },
    async objectPin(object, type) {
      try {
        switch (type) {
          case 'item':
            this.itemSelectDialog = !this.itemSelectDialog
            this.itemsSelected = []
            if (!Array.isArray(object)) {
              this.changeItem(object)
            } else {
              this.itemsSelected = object
            }
            await this.insertOrderItem()
            break
          case 'company':
            this.companySelectDialog = false
            await this.changeCompany(object, 'empresa')
            break
          case 'departament':
            this.departamentSelectDialog = !this.departamentSelectDialog
            this.updateOrderBehavior(object, 'departamento')
            break

          case 'paymentCondition':
            if (object) {
              this.order.condicaoPgto = object
              this.order.ct = this.getCTCondicaoPgto(object.CTS)
            } else {
              this.order.condicaoPgto = undefined
              this.order.ct = undefined
            }
            break
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },

    getCalculatedItem(data) {
      let typePrice = data.tipoPreco ?? this.order.tipoPreco
      let currency = this.systemCurrency[this.order.moeda].cifrao
      let valorTabela = parseFloat(data.item[typePrice][currency])
      let valorItem = parseFloat(data.item['PRECOITEM'][currency])

      if (data.item.EMOFERTA == 'S')
        valorTabela = parseFloat(data.item['PRECOITEM'][currency])

      let valorItemCdesc =
        (valorTabela - valorItem).toFixed(this.componentPrecision) * 1
      let percentualDesconto = 0

      if (valorItemCdesc < 0) {
        valorTabela = valorItem
        valorItemCdesc = 0
      } else {
        percentualDesconto = (valorItemCdesc / valorTabela).toFixed(2) * 100
      }
      let obj = {
        SEQUENCIALORCAMENTO: `${this.order.sequencial}`,
        QUANTIDADE: data.quantidade <= 0 ? 1 : parseFloat(data.quantidade),
        PRECO: valorItem,
        PERCENTUALDESCONTO: percentualDesconto,
        VALORDESCONTOUNITARIO: valorItemCdesc,
        TIPOPRECO: this.indexPriceTypes,
        MOEDAORCAMENTO: this.order.moeda,
        ITEM: { ...data.item },
        VALORTOTAL: 0,
      }
      obj.VALORTOTAL = obj.PRECO * obj.QUANTIDADE
      if (this.formEdit.ambienteInformado.length > 0)
        obj.COMPLEMENTO = this.formEdit.ambienteInformado
      return obj
    },
    // Order Item Functions
    async insertOrderItem(complementoMensagem = '') {
      await this.validaQuantidade()
      try {
        let payload

        if (this.itemsSelected.length > 0) {
          let dados = []
          this.itemsSelected.forEach((e) => {
            const item = this.getCalculatedItem(
              {
                item: e,
                quantidade: e.quantidade ?? 1,
              },
              this.formItem.tipoPreco
            )
            dados.push(item)
          })

          payload = {
            ITENS: dados,
            SEQUENCIALORCAMENTO: `${this.order.sequencial}`,
          }
        } else {
          if (
            this.formItem.item.CODIGO == null ||
            this.formItem.item.DESCRICAO == null
          )
            throw `${this.$t('pdv.insertOrderItemError1')}`

          payload = this.getCalculatedItem(
            this.formItem,
            this.formItem.tipoPreco
          )
        }

        if (this.formEdit.ambienteInformado.length > 0)
          payload.COMPLEMENTO = this.formEdit.ambienteInformado

        this.setLoadingDialogMessage(
          `${this.$t('dialogs.insertOrderItem')} ${complementoMensagem}`
        )
        this.showLoadingDialog(true)
        let errorItems = []
        try {
          const response = await this.addOrderItem(payload)
          if (response && response.error) {
            response.error.forEach((element) => {
              errorItems.push({
                erro: `${this.$t('pdv.insertOrdemItemError')}`,
                mensagem: element,
              })
            })
          }
        } catch (error) {
          const message = error.substring(0, error.indexOf('(SQL:') - 1)

          errorItems.push({
            erro: `Cód.: ${payload.ITEM.CODIGO}`.trim(),
            mensagem: message.length > 0 ? message : error,
          })
        }

        if (errorItems.length > 0)
          await this.$refs.confirmPendingBills.open(
            `${this.$t('pdv.insertOrderItemMultiError')}`,
            errorItems,
            {
              color: 'error darken-3',
              width: 1024,
              useTable: true,
              darkTable: true,
            }
          )
        await this.$nextTick()
        this.resetFormItem()
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },

    resetFormItem() {
      this.formItem = {
        item: {},
        quantidade: 1,
        preco: 0.0,
        tipoPreco: this.order.tipoPreco ?? 'PRECOVAREJO',
        condicaoPgto: this.order.condicaoPgto,
        desconto: 0,
      }
      this.itemsSelected = []
    },

    async alteraQuantidade($event) {
      try {
        if ($event.target.value <= 0)
          throw {
            error: `${this.$t('validation-messages', { quantidade: '1' })}`,
          }
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          let object = this.selectedItem
          object.QUANTIDADE = $event.target.value
          this.updateItem(object)
        }, 1000)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    async updateItem(object) {
      try {
        this.showLoadingDialog(true)
        this.setLoadingDialogMessage(
          `${this.$t('dialogs.updateOrderItem', { item: object.ITEM })}`
        )
        await this.updateOrderItem(object)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },

    selectItem(item) {
      if (item.value) {
        let itemCopy = item
        this.selectedItem = { ...itemCopy.item }
      } else {
        this.selectedItem = {}
        this.editingItem = false
        this.selectedTab = 2
      }
    },

    async deleteItem() {
      try {
        this.setLoadingDialogMessage(
          `${this.$t('dialogs.deleteOrderItem', {
            item: this.selectedItem.SEQUENCIAL,
          })}`
        )
        this.showLoadingDialog(true)
        let response = await this.removeOrderItem(this.selectedItem)
        this.selectedItem = {}
        this.selectedTab = 1
        this.$toasted.success(response)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },

    async reloadOrderItens() {
      try {
        this.setLoadingDialogMessage(this.$t('dialogs.reloadOrderItens'))
        this.showLoadingDialog(true)
        await this.getOrderItens({ orcamento: this.order.sequencial })
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },
    // Order Functions
    async submitOrder() {
      try {
        this.showLoadingDialog(true)
        this.setLoadingDialogMessage(
          `${this.$t('dialogs.submitOrder', { numero: this.order.numero })}`
        )

        const updatedOrder = {
          ...this.order,
          liberado: 'P',
          newParcelamentos: this.newParcelamentos,
        }

        let response = await this.updateOrder(updatedOrder)
        this.$toasted.success(response)

        if (localStorage.getItem('LAST_ORDER')) {
          await localStorage.removeItem('LAST_ORDER')
        }

        await this.startPreOrder()
        return true
      } catch (error) {
        this.$toasted.error(error, { duration: null })
        return false
      } finally {
        this.showLoadingDialog(false)
      }
    },

    async verifyItemTaxaEntrega() {
      const taxaAutomatica = this.getFlagSetado('TaxaDeEntregaAutomatica')
      const itemTaxaEntrega = this.getFlagSetado('ItemTaxaDeEntrega')
      const informarValor = this.getFlagSetado('InformaValorTaxaEntrega')

      let isInserirItem = false
      if (itemTaxaEntrega) {
        const item = this.orderItens.filter(
          (element) => element.ITEM == itemTaxaEntrega.PARAMETRO
        )
        if (!item || item.length <= 0)
          if (!taxaAutomatica) {
            isInserirItem = await this.$refs.confirmDialog.open(
              this.$t('pdv.addItemDelivery'),
              this.$t('pdv.addItemDelivery'),
              { color: 'error darken-3' }
            )
          } else isInserirItem = true

        if (isInserirItem) {
          let obj = {
            page: 1,
            tipoPreco: '0',
            codigo: itemTaxaEntrega.PARAMETRO,
          }

          await this.getDados(obj, 'item')
          let item = this.itemList[0]

          if (informarValor) {
            const res = await this.$refs.itemDelivery.open(
              `Informar ${this.$t('labels.valor')} ${this.$t(
                'labels.itemDelivery'
              )}`,
              item
            )
            if (res && res.item) {
              let currency = this.systemCurrency[this.order.moeda].cifrao
              item['PRECOITEM'][currency] = parseFloat(res.item.valor)
            }
          }
          this.changeItem(item)

          await this.insertOrderItem(this.$t('labels.itemDelivery'))
        }
      }
    },

    async closeOrder() {
      /*
       * Limpa os itens selecionados do localstorage com a chave 'selectedItemsPDV'
       */
      localStorage.removeItem('selectedItemsPDV')
      await this.verifyItemTaxaEntrega()

      if (this.$refs.formOrcamento && !this.$refs.formOrcamento.validate()) {
        this.$toasted.error(`${this.$t('pdv.closeOrderError')}`)
        return
      }

      if (!this.isGuest && this.newParcelamentos.length <= 0) this.newParcel()
      else this.submitOrder()
    },

    async clearOrder() {
      let userResponse = await this.$refs.confirmDialog.open(
        this.$t('titulos.clearOrder'),
        this.$t('dialogs.clearOrder'),
        { color: 'error darken-3' }
      )
      if (userResponse === true) {
        this.orderItens.forEach(async (element) => {
          this.selectedItem = { ...element }
          await this.deleteItem()
        })
      }
    },

    async saveOrder() {
      if (localStorage.getItem('LAST_ORDER'))
        localStorage.removeItem('LAST_ORDER')
      localStorage.setItem('LAST_ORDER', JSON.stringify(this.order))
    },

    async deleteLastOrder() {
      try {
        if (localStorage.getItem('LAST_ORDER'))
          localStorage.removeItem('LAST_ORDER')
        await this.resetOrderItens()
        await this.resetOrder()
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    async deleteOrder() {
      try {
        this.deleteOrderDialog = !this.deleteOrderDialog
        this.setLoadingDialogMessage(this.$t('dialogs.excluindoOrcamento'))
        this.showLoadingDialog(true)
        await this.deleteOrderAPI(this.order)
        this.$toasted.success(`${this.$t('pdv.deleteOrderSuccess')}`)
        this.startPreOrder()
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },

    async retrieveOrder() {
      let userResponse = await this.$refs.confirmDialog.open(
        `${this.$t('titulos.pendentOrder')}`,
        `${this.$t('dialogs.pendentOrder')}`,
        { color: 'grey darken-4' }
      )
      if (userResponse === true) {
        try {
          this.setLoadingDialogMessage(`${this.$t('dialogs.loadingLastOrder')}`)
          this.showLoadingDialog(true)

          this.setOrder(JSON.parse(localStorage.getItem('LAST_ORDER')))
          this.hasOrder = true

          this.$toasted.success(
            `${this.$t('pdv.retrieveOrderSuccess', {
              numero: this.order.numero,
            })}`
          )

          await this.getOrderItens({ orcamento: this.order.sequencial })

          this.companyList.push({ ...this.order.empresa })

          if (this.order.departamento.CODIGO)
            this.departamentList.push({ ...this.order.departamento })
        } catch (error) {
          this.$toasted.error(error, { duration: null })
        } finally {
          this.showLoadingDialog(false)
        }
      } else {
        await this.deleteLastOrder()
      }
    },

    async validateOrder() {
      let result = true
      let validation = ''

      if (!this.order.empresa || this.order.empresa.CODIGO <= 0)
        validation = `${this.$t('validation-messages.selectCliente')}`

      if (validation.length > 0) {
        this.$toasted.error(validation)
        result = false
      }

      // utiliza o retorno da função para poder forçar escolher a condição de pagamento se nao tiver escolhido ainda
      if (
        this.order.empresa &&
        this.order.empresa.CODIGO > 0 &&
        !this.order.condicaoPgto
      ) {
        result = await this.verifyFlagPaymentCondition(
          this.order.empresa.tipoVenda
        )
      }

      return result
    },

    async requestNewOrder() {
      if (localStorage.getItem('LAST_ORDER')) this.retrieveOrder()
      else {
        const canContinue = await this.validateOrder()
        if (!canContinue) return

        try {
          this.setLoadingDialogMessage(`${this.$t('dialogs.requestNewOrder')}`)
          this.showLoadingDialog(true)
          if (this.order.sequencial > 0) this.order.sequencial = 0
          let response = await this.newOrder(this.order)
          this.hasOrder = true

          // limpar a lista, pois quando faz um novo orçamento, fica lista do antigo orçamento o que pode acabar
          // selecionando um item ja na comboBox
          await this.clearItemList()
          await this.updateTab()

          this.$toasted.success(response)
        } catch (error) {
          this.$toasted.error(error, { duration: null })
          this.hasOrder = false
        } finally {
          this.showLoadingDialog(false)
        }
      }
    },

    async loadOrder(loadObject, showMessage = true) {
      if (this.loadOrderDialog) this.loadOrderDialog = false
      try {
        if (showMessage)
          this.setLoadingDialogMessage(
            `${this.$t('dialogs.carregandoOrcamento', {
              numero: loadObject.numero ?? loadObject.sequencial,
            })}`
          )
        this.showLoadingDialog(true)

        let response = await this.loadOrderAPI(loadObject)
        this.hasOrder = true

        if (
          !this.companyList.find(
            (obj) => obj.CODIGO == this.order.empresa.CODIGO
          )
        )
          this.companyList.push({ ...this.order.empresa })

        if (this.order.departamento.CODIGO)
          if (
            !this.departamentList.find(
              (obj) => obj.CODIGO === this.order.departamento.CODIGO
            )
          )
            this.departamentList.push({ ...this.order.departamento })

        this.selectedItemPrevisaoEntrega = this.itemsTipoPrevisao.findIndex(
          (e) => e.value == this.order.tipoPrevisaoEntrega
        )

        await this.getOrderItens({ orcamento: this.order.sequencial })

        this.formItem.tipoPreco = this.order.tipoPreco ?? 'PRECOVAREJO'
        // apenas forçar escolher a condição de pagamento caso não exista no orçamento
        await this.verifyFlagPaymentCondition()

        // limpar a lista, pois quando faz um novo orçamento, fica lista do antigo orçamento o que pode acabar
        // selecionando um item ja na comboBox
        await this.clearItemList()

        let dataAgora = formatDateToTimestamps(getTodayDateTimeLocal())
        if (
          dataAgora > this.order.previsaoEntrega ||
          !this.order.previsaoEntrega
        )
          this.order.previsaoEntrega = getTodayDateTimeLocal()

        // se showMessage for false, não exibir (ex. revertendo o orçamento)
        if (showMessage)
          this.$toasted.success(
            this.$t('pdv.retrieveOrderSuccess', { numero: response })
          )
      } catch (error) {
        this.$toasted.error('[PDV-LO]' + error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },

    async verifyFlagPaymentCondition(condicaoDefault = null) {
      // resultado do return é usado apenas ao salvar o orçamento
      // true ok false erro
      if (
        this.isGuest
        // || this.order.geradoPelaRotina == this.orderType.guest
      )
        return true

      const flag = this.getFlagSetado('CalculaAcrescimoFinanceiroVendaAPrazo')

      // sempre chama essa função na troca de empresa e deve verificar a condição
      // if (flag && this.order.empresa && !this.order.condicaoPgto) {

      if (flag && !this.order.condicaoPgto) {
        // vai esperar a seleção da condição
        // se nao tiver selecionado a condicao erro
        // condicaoDefault para exibir no componente
        return await this.$refs.paymentConditionSelect.open(condicaoDefault)
      }
      return true
    },

    // Other Functions
    changeSearchItemDialog() {
      // this.showSearchItemDialog = !this.showSearchItemDialog;
      this.$router.push({ name: 'pdv.search.item' })
    },

    async startPreOrder() {
      try {
        this.closeOrderDialog = false
        this.newParcelamentos = []

        await this.getDados({ todos: 'S' }, 'departament')
        if (this.currency.length == 0) await this.getcurrencyAPI({ page: 1 })
        if (localStorage.getItem('LAST_ORDER')) {
          this.retrieveOrder()
        } else {
          await this.resetOrder()
          await this.resetOrderItens()
          this.hasOrder = false
          this.selectedTab = 1

          let preOrder = { ...this.order }

          preOrder.filial = this.authUser.filial

          preOrder.data = getTodayDateTimeLocal()
          preOrder.previsaoEntrega = getTodayDateTimeLocal()
          preOrder.tipoPrevisaoEntrega = 'Entrega'
          this.selectedItemPrevisaoEntrega = this.itemsTipoPrevisao.findIndex(
            (e) => e.value == preOrder.tipoPrevisaoEntrega
          )

          if (!this.authUser.guest) {
            preOrder.vendedor.CODIGO = this.authUser.CODIGO
            preOrder.vendedor.NOME = this.authUser.NOMECOMPLETO
            preOrder.geradoPelaRotina = this.orderType.web
          } else {
            const companyGuest = {
              CODIGO: parseInt(this.authUser.CODIGO),
              NOME: this.authUser.NOME,
              CGC: this.authUser.CGC,
            }

            if (
              !this.companyList.find((obj) => obj.CODIGO == companyGuest.CODIGO)
            ) {
              this.companyList.push(companyGuest)
            }

            const company = await this.getCompanyAPI(companyGuest.CODIGO)
            preOrder.vendedor = { ...company.vendedor }
            preOrder.empresa = companyGuest
            preOrder.geradoPelaRotina = this.orderType.guest
            preOrder.tipoPreco = 'PRECOVAREJO'
          }
          await this.setOrder(preOrder)
        }
      } catch (error) {
        this.$toasted.error('ERRO CATCH START PRE ORDER', {
          duration: null,
        })
      }
    },

    getImage(item = null) {
      let path
      if (item && item.imagens && item.imagens.images_base64.IMAGEM) {
        path = 'data:image/jpg;base64,' + item.imagens.images_base64.IMAGEM
      }
      return path
    },

    closeOverlay() {
      this.overlay.overlay = false
    },
    toogleOverlay(item = null) {
      const imagensName = ['IMAGEM', 'IMAGEM1', 'IMAGEM2', 'IMAGEM3']
      this.imagesList = []
      this.overlay.model = 0
      this.overlay.item = item
      if (item && item.imagens) {
        this.overlay.overlay = !this.overlay.overlay
        this.overlay.especificacoes = item.imagens.especificacoes
        imagensName.forEach((key) => {
          if (item.imagens.images_base64[key]) {
            let path =
              'data:image/jpg;base64,' + item.imagens.images_base64[key]
            this.imagesList.push(path)
          }
        })
      }
    },
    /*
     * Limpa os itens selecionados do localstorage com a chave 'selectedItemsPDV'
     */
    removeItemsSelecteds() {
      localStorage.removeItem('selectedItemsPDV')
    },
  },

  mounted() {
    /* Limpa do local storage se houver itens salvos do select PDV  */
    this.removeItemsSelecteds()
    this.startPreOrder()
  },

  async beforeRouteLeave(to, from, next) {
    if (to.name == 'Login') {
      next()
    } else if (this.hasOrder) {
      const userResponse = await this.$refs.leaveRouteDialog.open(
        `${this.$t('titulos.beforeRouteLeavePDV')}`,
        `${this.$t('dialogs.beforeRouteLeavePDV')}`,
        { color: 'primary darken-3' }
      )

      if (userResponse === 'Y') {
        await this.saveOrder()
        next()
      } else if (userResponse === 'N') {
        await this.deleteLastOrder()
        next()
      } else next(false)
    } else {
      next()
    }
  },
}
</script>

<style></style>
